import Router from "shared/router"
import "shared/scss/global.scss"

function App() {
  return <Router />
}

export default App
